module.exports = __webpack_public_path__ + "static/media/Protein Cookies 100g.bb3fdd85.jpg";